<template>
  <form @submit.prevent="createAsset">
    <DxForm :form-data="newAsset"  label-location="left" :min-col-width="350" :align-item-labels-in-all-groups="false">
      
      <DxGroupItem :col-count="1" :min-col-width="330">
        <DxSimpleItem data-field="name" :is-required="true" />
        <DxSimpleItem 
          data-field="desc" 
          editor-type="dxTextBox"
          :editor-options="{ maxLength: 300 }" 
        />
        <DxSimpleItem 
          data-field="compType" 
          template="kindList"
          :label="{text: 'Type asset'}"
          
        />
        <DxSimpleItem data-field="isEnabled" editor-type="dxCheckBox" />  
      </DxGroupItem>
      
      
      <DxGroupItem :col-count="1" :min-col-width="330" caption="Battery" :visible="showBattProperties" >
         <DxSimpleItem 
              data-field="num_strings_parallel" 
              :label="{text:'Number of strings'}" 
              editor-type="dxNumberBox"
              :editor-options="{ min:1, max:32, showSpinButtons:true}" 
            />
            <DxSimpleItem 
              data-field="num_modules_parallel" 
              :label="{text:'Number of parallel modules'}" 
              editor-type="dxNumberBox"
              :editor-options="{ min:1, max:32, showSpinButtons:true, value:1, disabled: true}" 
            />
            <DxSimpleItem 
              data-field="num_modules_series" 
              :label="{text:'Number of serial modules'}" 
              editor-type="dxNumberBox"
              :editor-options="{ min:1, max:32, showSpinButtons:true}" 
            />
            <DxSimpleItem 
              data-field="num_cell_parallel" 
              :label="{text:'Number of parallel cells'}" 
              editor-type="dxNumberBox"
              :editor-options="{ min:1, max:32, showSpinButtons:true}" 
            />
            <DxSimpleItem 
              data-field="num_cell_series" 
              :label="{text:'Number of serial cells'}" 
              editor-type="dxNumberBox"
              :editor-options="{ min:1, max:32, showSpinButtons:true}" 
            />
      </DxGroupItem>

      <DxGroupItem :col-count="2" :min-col-width="160">
        <DxButtonItem :button-options="{ type:'danger', width: '100%', text: 'Cancel', useSubmitBehavior: false, onClick: cancelCreation }" />
        <DxButtonItem :button-options="{ type:'success', width: '100%', text: 'Create Asset', useSubmitBehavior: true }" />
      </DxGroupItem>

      <template #kindList>
        <DxLookup
          :data-source="nodesList"
          display-expr="name"
          value-expr="id"
          :on-value-changed="TypeCompChanged"
          v-model:value="newAsset.compType"
        />
      </template>
      
    </DxForm>

    
  </form>
</template>

<script>
import DxForm, {
  DxGroupItem,
  DxButtonItem,
  DxSimpleItem,
} from 'devextreme-vue/form';
import { DxLookup } from 'devextreme-vue/lookup';
import notify from 'devextreme/ui/notify';
import { ref, reactive } from 'vue';
import RawDataService from '../services/RawDataServiceTemplate';

export default {
  components: {
    DxForm,
    DxGroupItem,
    DxButtonItem,
    DxSimpleItem,
    DxLookup,
  },
  emits: ['asset-update', 'cancel'],
  setup(props, { emit }) {
    const newAsset = reactive({
      name: null,
      desc: null,
      compType:1,
      isEnabled: false,

      // Batt parameters
      num_strings_parallel:1,
      num_modules_parallel:1,
      num_modules_series:1,
      num_cell_parallel:1,
      num_cell_series:1,
    });
    //const stErrorCb = err => { notify(err.message, "error", 3000); }
    const assetsDataService = new RawDataService('masters/assets');
    //const nodesDataService = new RawDataService('masters/enfyoGraphNodes');
    const modelsDataService = new RawDataService('sunspec/models');
    //const staticsDataService = new RawDataService('statics/tables');
    const nodesList = ref ([]);
    //const promiseNodes = nodesDataService.getAll();
    //const promiseNodeFams = staticsDataService.getByKey('graphNodeFamilies');

    const loadForm =  ()=>{
    
    modelsDataService.getAll().then(data => {
     nodesList.value=data;
    });
    console.log(nodesList.value)
    
    }
    loadForm();
    
    
    const clearAssetObj = () => {
      newAsset.name=null;
      newAsset.desc=null;
      newAsset.compType=1;
      newAsset.isEnabled=false;

      newAsset.num_strings_parallel=1;
      newAsset.num_modules_parallel=1;
      newAsset.num_modules_series=1;
      newAsset.num_cell_parallel=1;
      newAsset.num_cell_series=1;
    };

    const createAsset = async () => {
      try{
        const res = await assetsDataService.create(Object.assign(newAsset,{parameters:JSON.stringify({
                                        num_strings_parallel:newAsset.num_strings_parallel,
                                        num_modules_parallel:newAsset.num_modules_parallel,
                                        num_modules_series:newAsset.num_modules_series,
                                        num_cells_parallel:newAsset.num_cell_parallel,
                                        num_cells_series:newAsset.num_cell_series,
        })}));
        clearAssetObj();
        notify(res.message||'asset creation sent', "success", 4000);
        emit('asset-update', {  
          objectType: 'asset', 
          key: newAsset.name, 
          type:'insert',
          message: res.message||'asset creation sent',
          data: {
            assetId: newAsset.name,
            description: newAsset.desc,
            isEnabled: newAsset.isEnabled,

            parameters:JSON.stringify({ num_strings_parallel:newAsset.num_strings_parallel,
                                        num_modules_parallel:newAsset.num_modules_parallel,
                                        num_modules_series:newAsset.num_modules_series,
                                        num_cells_parallel:newAsset.num_cell_parallel,
                                        num_cells_series:newAsset.num_cell_series,})
          }
        });
      }catch(error){
        emit('cancel', { reason: error.message||'error creating asset' });
      }
    }
    const cancelCreation = () => {
      clearAssetObj();
      emit('cancel', { reason: 'action cancelled by user' });
    }
    

    const showBattProperties = ref(false)
    const TypeCompChanged = (e) =>{
      
      if(e.value==81)
        showBattProperties.value=true;
      else
        showBattProperties.value=false;
    }
    return {
      nodesList,
      newAsset,
      createAsset,
      cancelCreation,
      TypeCompChanged,
      showBattProperties
    }
  }
}
</script>

<style>

</style>